import { useGridFilter } from '@mint-lib/ag-grid/react';

import { useTranslation } from '@mint-lib/i18n';
import { Switch, typographyVariants } from '@mint-lib/tw-components';

type BooleanFilterModel = {
  filterType: 'boolean';
  filter: boolean;
};

type GridShowHiddenFilesFilterProps = {
  defaultValue: boolean;
  onModelChange: (model: null | BooleanFilterModel) => void;
};

export const GridShowHiddenFilesFilter = ({
  defaultValue = false,
  onModelChange,
}: GridShowHiddenFilesFilterProps) => {
  const { t } = useTranslation('@myn/import-hub');

  useGridFilter({
    doesFilterPass: () => true,
  });

  const handleIncludeHiddenToggle = (checked: boolean) => {
    onModelChange({
      filterType: 'boolean',
      filter: checked,
    });
  };

  return (
    <div className="mt-3 border-t border-t-border-secondary p-3">
      <div className="show-hidden-files-filter flex h-8 items-center gap-2">
        <Switch
          defaultChecked={defaultValue}
          onCheckedChange={handleIncludeHiddenToggle}
          aria-label={t('Include hidden')}
          size="small"
        />
        <span
          className={typographyVariants({
            variant: 'bodyShort02',
            color: 'primary',
          })}
        >
          {t('Include hidden')}
        </span>
      </div>
    </div>
  );
};
